// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._10wP4JklI2P0Pd8qWOucP9 {\n  display: inline-flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n@keyframes _2yo4f0nqUnj2duhOfptRbD {\n  from {\n    transform: rotate(0deg);\n  }\n  to { \n    transform: rotate(360deg);\n  }\n}\n\n.YrvpOQE0CJwG4cUYywhnE {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0.5rem;\n  color: rgba(255, 255, 255, 0.8);\n  text-transform: lowercase;\n  text-decoration: none;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n.p-RiravriLp66loXShzpN,\n.YrvpOQE0CJwG4cUYywhnE:hover {\n  color: #FFF;\n}\n\n.C5Htkrdh00wxjcnB1kKnP {\n  margin-right: 0.25rem;\n  color: #fff;\n}\n", ""]);
// Exports
exports.locals = {
	"NavListItem": "_10wP4JklI2P0Pd8qWOucP9",
	"NavLink": "YrvpOQE0CJwG4cUYywhnE",
	"ActiveNavLink": "p-RiravriLp66loXShzpN",
	"Icon": "C5Htkrdh00wxjcnB1kKnP",
	"spin": "_2yo4f0nqUnj2duhOfptRbD"
};
module.exports = exports;
